import styled from '@emotion/styled';
import { Select } from '@material-ui/core';

const StyledSelect = styled(Select)({
  width: 320,
  maxWidth: '100%'
});

export default StyledSelect;
